import { Briefcase, GraduationCap, BookOpen, Hotel, Antenna } from "lucide-react";

const TIMELINE = [
  {
    period: "04 / 2022 — Súčasnosť",
    company: "EMIS, spol. s r.o.",
    role: "Marketing Manager",
    desc:
      "Riadenie marketingu pre tech projekty mapsfy.com, UAVIS a geovio. Strategické plánovanie, branding, výkonnostné kampane, analytika, správa sociálnych sietí a webových stránok.",
    tags: ["mapsfy.com", "UAVIS", "geovio"],
    icon: Briefcase,
    accent: true,
  },
  {
    period: "08 / 2018 — 04 / 2022",
    company: "KRUGEL EXIM, spol. s r.o.",
    role: "Marketing Specialist",
    desc:
      "Budovanie značky Keline — kompletný marketing mix, e-commerce, kampane, vizuálna identita a B2C komunikácia.",
    tags: ["Keline", "B2C", "E-commerce"],
    icon: Antenna,
  },
   {
    period: "02 / 2018 — 04 / 2018",
    company: "Tenis centrum management, s.r.o.",
    role: "Marketing Manager",
    desc:
      "Návrh a tvorba grafických vizuálov (cenníky, bannery, plagáty...), správa sociálnych sietí a webovej stránky.",
    tags: ["Tenis", "Brand", "Visual ID"],
    icon: Hotel,
  },
  {
    period: "09 / 2014 — 08 / 2017",
    company: "FMK UCM",
    role: "PhD. Researcher & Lecturer",
    desc:
      "Doktorandský výskum v oblasti marketingovej komunikácie. Pedagogická činnosť, publikácie a obhajoba dizertácie.",
    tags: ["PhD.", "Research", "Lecturer"],
    icon: GraduationCap,
  },
];

export default function Experience() {
  return (
    <section
      id="skusenosti"
      data-testid="experience-section"
      className="relative py-24 lg:py-32 border-t border-white/[0.06]"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <span className="pill-tag" data-testid="experience-pill">
              <span className="pill-dot"></span>
              04 — Pracovné skúsenosti
            </span>
            <h2 className="mt-6 text-4xl lg:text-6xl font-extrabold tracking-tight leading-[1.02]">
              Cesta od
              <br />
              <span className="text-[#C6F432]">akadémie</span> po
              <br />
              senior tím.
            </h2>
            <p className="mt-6 text-white/55 max-w-sm">
              Desať+ rokov v marketingu — od výskumu cez B2C značku až po
              technologické platformy.
            </p>
          </div>

          <div className="lg:col-span-8 relative">
            <div className="absolute left-5 lg:left-7 top-2 bottom-2 w-px bg-gradient-to-b from-[#C6F432]/60 via-white/10 to-transparent" />

            <div className="space-y-10">
              {TIMELINE.map((t, i) => (
                <div
                  key={t.company}
                  data-testid={`timeline-item-${i}`}
                  className="relative pl-16 lg:pl-20 group"
                >
                  <div
                    className={`absolute left-0 lg:left-2 top-1 w-10 h-10 rounded-full flex items-center justify-center border ${
                      t.accent
                        ? "bg-[#C6F432] border-[#C6F432] shadow-[0_0_30px_rgba(198,244,50,0.45)]"
                        : "bg-[#0A0A0A] border-white/15 group-hover:border-[#C6F432]/60"
                    } transition-all`}
                  >
                    <t.icon
                      className={`w-5 h-5 ${
                        t.accent ? "text-[#0A0A0A]" : "text-white/70 group-hover:text-[#C6F432]"
                      } transition-colors`}
                    />
                  </div>

                  <div className="flex flex-col lg:flex-row lg:items-baseline lg:gap-4">
                    <div className="text-[12px] font-mono uppercase tracking-[0.18em] text-white/40 mb-2 lg:mb-0">
                      {t.period}
                    </div>
                  </div>

                  <h3 className="mt-1 text-2xl lg:text-3xl font-bold tracking-tight">
                    {t.role}
                    <span className="text-white/40 font-medium"> · {t.company}</span>
                  </h3>

                  <p className="mt-3 text-white/60 max-w-2xl leading-relaxed">
                    {t.desc}
                  </p>

                  <div className="mt-4 flex flex-wrap gap-2">
                    {t.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-[11px] font-mono uppercase tracking-wider px-2.5 py-1 rounded-md bg-white/[0.04] border border-white/[0.07] text-white/65"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
